import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { settingAPI } from '../services/api';

const WhatsAppWidget = () => {
  const { t } = useLanguage();
  const [whatsappPhone, setWhatsappPhone] = useState('');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await settingAPI.getAllSettings();
        setWhatsappPhone(response.data?.whatsappPhone || '905551234567');
      } catch (error) {
        setWhatsappPhone('905551234567');
      }
    };
    loadSettings();
  }, []);

  if (!whatsappPhone) return null;

  return (
    <a
      href={`https://wa.me/${whatsappPhone}?text=${encodeURIComponent(t('whatsappGreetingMessage'))}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsappSupport')}
      title={t('whatsappSupport')}
      className="fixed bottom-5 right-5 z-50 flex 
      items-center justify-center w-14 h-14 rounded-full bg-green-600 text-white
       shadow-2xl hover:bg-green-700 hover:scale-110 transition-all 
       duration-300 animate-[bounce_2s_ease-in-out_3]relative -translate-y-[50%]"
    >
      <i className="fab fa-whatsapp text-3xl"></i>
    </a>
  );
};

export default WhatsAppWidget;
